<script setup lang="ts">
import { KeyRound } from 'lucide-vue-next';
import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'vue';
import type { ParseKeys } from 'i18next';

withDefaults(
  defineProps<{
    class?: HTMLAttributes['class'];
    tokenDetailsClass?: HTMLAttributes['class'];
    name?: string;
    accessLevel: ParseKeys;
    truncate?: boolean;
    isSmall?: boolean;
  }>(),
  {
    class: null,
    tokenDetailsClass: null,
    name: '',
    truncate: false,
    isSmall: false
  }
);
</script>
<template>
  <div
    :class="cn('flex gap-2.5', $props.class)"
    data-testid="token-info-block"
    :data-id="`token-info-block-${name}`"
  >
    <KeyRound stroke-width="1.5" class="h-4 w-4" />
    <div :class="tokenDetailsClass">
      <p
        :class="
          cn(
            'text-xs font-semibold text-gray-800 max-w-64 break-words',
            truncate && 'truncate',
            isSmall && 'mt-0.5'
          )
        "
        :title="name"
        data-testid="token-info-block-name"
      >
        {{ name }}
      </p>
      <p
        :class="
          cn(
            'text-xs font-medium text-gray-600 max-w-64 break-words',
            truncate && 'truncate',
            isSmall && 'mt-0.5'
          )
        "
        :title="$t(accessLevel)"
        data-testid="token-info-block-access-level"
      >
        {{ $t(accessLevel) }}
      </p>
    </div>
    <slot></slot>
  </div>
</template>
